/** Public thread feeds need no credential. Private discussions never use this URL. */
export function communityFeedHref(threadId?: string) {
  return `/community-feed.xml${threadId ? `?thread=${encodeURIComponent(threadId)}` : ''}`
}

/** Only public research task updates; private work is never syndicated. */
export function workFeedHref(taskId: string) {
  return `/community-work-feed.xml?task=${encodeURIComponent(taskId)}`
}
